/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PpeTypeDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: PpeTypeDefinitionDto.source;
    label?: string;
    isSerialNumberMandatory?: boolean;
}

export namespace PpeTypeDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
